/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type AggregatesListingPriceCardContent_listing$ref = any;
type aggregatesListingCampaignEnquiry_listing$ref = any;
export type OfferType = "buy" | "rent";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingPriceCard_listing$ref: FragmentReference;
declare export opaque type AggregatesListingPriceCard_listing$fragmentType: AggregatesListingPriceCard_listing$ref;
export type AggregatesListingPriceCard_listing = {|
  +salePrice: ?number,
  +offerType: OfferType,
  +grossRentMonthly: ?number,
  +grossRentM2yearly: ?number,
  +salePricePerLivingSurface: ?number,
  +salePricePerLandSurface: ?number,
  +currency: ?string,
  +offlineSince: ?string,
  +createdAt: string,
  +bookOnline: ?boolean,
  +id: string,
  +slug: string,
  +agencyId: ?string,
  +agencyName: ?string,
  +agencySlug: ?string,
  +agencyLogoUrl: ?string,
  +agencyRating: ?number,
  +agencyReviewsCount: ?number,
  +agencyReference: ?string,
  +agencyContactPhoneNumber: ?string,
  +visitContactPerson: ?string,
  +visitContactPhoneNumber: ?string,
  +url: ?{|
    +originalDomain: string
  |},
  +urls: $ReadOnlyArray<{|
    +url: string,
    +originalDomain: string,
    +mergedListingId: string,
  |}>,
  +$fragmentRefs: AggregatesListingPriceCardContent_listing$ref & aggregatesListingCampaignEnquiry_listing$ref,
  +$refType: AggregatesListingPriceCard_listing$ref,
|};
export type AggregatesListingPriceCard_listing$data = AggregatesListingPriceCard_listing;
export type AggregatesListingPriceCard_listing$key = {
  +$data?: AggregatesListingPriceCard_listing$data,
  +$fragmentRefs: AggregatesListingPriceCard_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalDomain",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingPriceCard_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grossRentMonthly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grossRentM2yearly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePricePerLivingSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePricePerLandSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offlineSince",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bookOnline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencySlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyLogoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyRating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyReviewsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyContactPhoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitContactPerson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitContactPhoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalUrl",
      "kind": "LinkedField",
      "name": "url",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalUrl",
      "kind": "LinkedField",
      "name": "urls",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mergedListingId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingPriceCardContent_listing"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "aggregatesListingCampaignEnquiry_listing"
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '83afa54ff180213d16dcffc4d360c0d0';

export default node;
